import React from 'react';
import Helmet from "react-helmet";

export default ({children}) => (
    <div className="rounded shadow my-4">
        <a className="twitter-timeline" data-lang="it" data-height="400" href="https://twitter.com/iononrischio?ref_src=twsrc%5Etfw%7Ctwcamp%5Eembeddedtimeline%7Ctwterm%5Escreen-name%3Aiononrischio%7Ctwcon%5Es2">
            Tweet di @iononrischio
        </a>
        <Helmet>
            <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"/>
        </Helmet>
    </div>
);
